(function () {
  function el(tag, cls, html) {
    const e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html !== undefined) e.innerHTML = iconize(html);
    return e;
  }

  const RUNE_GLYPHS = RB.Text.RUNE_GLYPHS;
  const normalizeIcons = RB.Text.normalizeIcons;
  const plainText = RB.Text.plain;

  function iconize(html) {
    let out = normalizeIcons(html);
    out = out.replace(/:rb_energy_(\d+):/g, "<span class='tbe'>$1</span>");
    out = out.replace(/:rb_exhaust:/g, "<span class='tbx'>⟳</span>");
    out = out.replace(/:rb_might:/g, "<span class='tbm'>M</span>");
    out = out.replace(/:rb_rune_(\w+):/g, function (m2, d) {
      const g = RUNE_GLYPHS[d] || [d, "rainbow"];
      return "<span class='tbr tbr-" + g[1] + "'>" + g[0] + "</span>";
    });
    return out;
  }
  function fmtText(text) {
    let out = iconize(esc(text));
    out = out.replace(/\b([Rr]ules?\s+)(\d{3}(?:\.\w+)*)/g, function (m2, word, num) {
      return "<span class='rref' data-rule='" + num + "'>" + word + num + "</span>";
    });
    return out.replace(/\n/g, "<br>");
  }

  function esc(s) {
    return String(s === undefined || s === null ? "" : s)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }

  function liveSelection() {
    const s = typeof window !== "undefined" && window.getSelection ? window.getSelection() : null;
    return s && s.rangeCount && !s.isCollapsed ? s : null;
  }

  function textSelected(root) {
    const s = liveSelection();
    if (!s) return false;
    if (!root) return true;
    const n = s.anchorNode;
    if (!n) return false;
    return root.contains(n.nodeType === 1 ? n : n.parentNode);
  }

  function dropTextSelection() {
    const s = liveSelection();
    if (s) s.removeAllRanges();
  }

  function pointerDrag(cfg) {
    const d = { cand: null, active: false };
    const finish = function (ev) {
      const c = d.cand, was = d.active;
      d.cand = null; d.active = false;
      if (was && typeof document !== "undefined" && document.body) document.body.classList.remove("dragsel");
      if (c) cfg.end(c, ev, was);
    };
    if (typeof document !== "undefined" && document.addEventListener) {
      document.addEventListener("pointermove", function (ev) {
        if (!d.cand) return;
        if (!d.active) {
          if (cfg.canStart && !cfg.canStart(d.cand)) return;
          const dx = ev.clientX - d.cand.x, dy = ev.clientY - d.cand.y;
          if (dx * dx + dy * dy < 49) return;
          d.active = true;
          dropTextSelection();
          document.body.classList.add("dragsel");
          cfg.start(d.cand, ev);
        }
        cfg.move(d.cand, ev);
      });
      document.addEventListener("pointerup", finish);
      document.addEventListener("pointercancel", function () { finish(null); });
    }
    return {
      arm(cand, ev) { d.cand = Object.assign({ x: ev.clientX, y: ev.clientY }, cand); d.active = false; },
      cancel() { finish(null); },
      get cand() { return d.cand; },
      get active() { return d.active; },
    };
  }

  if (typeof document !== "undefined" && document.addEventListener) {
    document.addEventListener("dragstart", function (ev) { ev.preventDefault(); });
  }

  const CARD_RATIO = 744 / 1039;
  const LAND_RATIO = 744 / 533;

  function gridFit(grid, opts) {
    const o = opts || {};
    const gap = o.gap !== undefined ? o.gap : 8;
    const minW = o.min || 120;
    const ratio = o.ratio || CARD_RATIO;
    const w = grid.clientWidth;
    const h = o.height !== undefined ? o.height : grid.clientHeight;
    let cols = Math.floor((w + gap) / (minW + gap));
    if (o.maxCols) cols = Math.min(cols, o.maxCols);
    cols = Math.max(1, cols);
    const tileW = (w - gap * (cols - 1)) / cols;
    const tileH = tileW / ratio;
    let rows = Math.floor((h + gap) / (tileH + gap));
    rows = Math.max(1, rows);
    grid.style.gridTemplateColumns = "repeat(" + cols + ", minmax(0, 1fr))";
    return { cols: cols, rows: rows, per: cols * rows, tileW: tileW, tileH: tileH };
  }

  function onResize(fn) {
    let raf = 0;
    const run = function () {
      raf = 0;
      fn();
    };
    const handler = function () {
      if (raf) return;
      raf = requestAnimationFrame(run);
    };
    window.addEventListener("resize", handler);
    return function () { window.removeEventListener("resize", handler); };
  }

  function dismissNotice() {
    const old = document.getElementById("noticetoast");
    if (old) old.remove();
  }

  function showNotice(msg) {
    dismissNotice();
    if (!msg) return;
    const box = el("div", null);
    box.id = "noticetoast";
    box.appendChild(el("span", "noticetext", "⚠ " + fmtText(msg)));
    const close = el("button", "noticeclose", "×");
    close.title = "Dismiss";
    close.onclick = dismissNotice;
    box.appendChild(close);
    document.body.appendChild(box);
  }

  window.UIDOM = {
    showNotice: showNotice, dismissNotice: dismissNotice,
    pointerDrag: pointerDrag, textSelected: textSelected, dropTextSelection: dropTextSelection, el: el, esc: esc, iconize: iconize, gridFit: gridFit, onResize: onResize, CARD_RATIO: CARD_RATIO, LAND_RATIO: LAND_RATIO, fmtText: fmtText, plainText: plainText, normalizeIcons: normalizeIcons, RUNE_GLYPHS: RUNE_GLYPHS };
})();
